<template>
  <b-modal :width="700" v-model="isModalActive">
    <div class="helpful-hint notification is-primary is-light">
      <img src="/zoom-conference.png">
      <h2 class="title is-2">More engagement, less work</h2>
      <!-- <p>Slides With Friends takes the difficulty of interaction off of your plate in a way that guarantees great results and leads to engagement that you can measure and show. </p> -->
      <!-- <p>Slides with friends makes engagement easy and predictable. Our interactive slides create engagement you can see, control, and measure.</p> -->
      <p>Slides With Friends takes away the difficulty of hosting an engaging event. Create highly interactive lessons, meetings, and more with real engagement you can prove.</p>
      <n-link @click="trackEvent('Exit Intent Register')" to="/register" class="button is-primary is-large">Get started for free</n-link>
    </div>
  </b-modal>
</template>
<script>
export default {
  data () {
    return {
      isModalActive: false
    }
  },
  computed: {
    loggedIn () {
      return this.$auth.loggedIn
    }
  },
  mounted () {
    if (!this.loggedIn) {
      this.log('user logged out, waiting 10s to add event listeners')
      setTimeout(() => {
        this.addListeners()
      }, 5000)
    }
  },
  methods: {
    addListeners () {
      if (this.loggedIn) { return }
      if (this.hasSeenHint('exit-intent-register')) { return }
      document.addEventListener('mouseout', this.handleMouseEvent)
    },
    handleMouseEvent (e) {
      const showExitIntent = !e.toElement && !e.relatedTarget && e.clientY < 10

      if (showExitIntent) {
        this.saveUserHint('exit-intent-register')
        document.removeEventListener('mouseout', this.handleMouseEvent)
        this.isModalActive = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.helpful-hint {
  padding: 2em 2em 3.5em;
  text-align: center;
  border-radius: 12px;

  p {
    margin: 1em 0 1.1em;
    font-size: 1.25em;
  }

  img {
    width: 250px;
    margin-top: -.5em;
    margin-bottom: -.5em;
  }

  .flex {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .button {
    margin-top: .5em;
  }
}
</style>
